/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Hyperlink = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19.7719 4.22831C17.9554 2.41185 15.0103 2.41185 13.1939 4.22831L10.4352 6.98696C8.61878 8.80342 8.61878 11.7485 10.4352 13.5649C10.7281 13.8578 11.203 13.8578 11.4959 13.5649C11.7888 13.272 11.7888 12.7972 11.4959 12.5043C10.2652 11.2736 10.2652 9.27829 11.4959 8.04762L14.2545 5.28897C15.4852 4.0583 17.4805 4.0583 18.7112 5.28897C19.9419 6.51964 19.9419 8.51495 18.7112 9.74561L15.9525 12.5043C15.6596 12.7972 15.6596 13.272 15.9525 13.5649C16.2454 13.8578 16.7203 13.8578 17.0132 13.5649L19.7719 10.8063C21.5883 8.98982 21.5883 6.04476 19.7719 4.22831ZM4.22806 19.7717C6.04452 21.5881 8.98957 21.5881 10.806 19.7717L13.5647 17.013C15.3811 15.1966 15.3811 12.2515 13.5647 10.435C13.2718 10.1422 12.7969 10.1422 12.504 10.435C12.2111 10.7279 12.2111 11.2028 12.504 11.4957C13.7347 12.7264 13.7347 14.7217 12.504 15.9523L9.74537 18.711C8.5147 19.9417 6.51939 19.9417 5.28872 18.711C4.05806 17.4803 4.05806 15.485 5.28872 14.2544L8.04738 11.4957C8.34027 11.2028 8.34027 10.7279 8.04738 10.435C7.75448 10.1422 7.27961 10.1422 6.98672 10.435L4.22806 13.1937C2.41161 15.0102 2.41161 17.9552 4.22806 19.7717Z"
                        fill={color}
                    />
                </svg>
        );
    };
